import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { toastError, countryActionId, cityActionId, industryActionId, stateActionId, toastSuccess, sessionExpireMessage, tokenInavlidMessage } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from "../../../utils/pagination";
import Header from '../../../common_components/Header';
import Loader from '../../../utils/Loader';
import { get_promoCode_list_action, delete_promoCode_action } from '../../../actions/adminAction/promoCode_action';
import moment from 'moment';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

class PromoCodeList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false, isFilterShow: false,
            CouponCode: '',
            disPer: '', expiry: '', status: '',
            PromoCodeID: '', currentPage: 1, recordsPerPage: 10, promoCodeList: [],
            FullAccess: false, ReadAccess: false, WriteAccess: false, UpdateAccess: false, DeleteAccess: false, DownloadAccess: false, Is_SpecialAccess: false, SendAccess: false
        }
        this.updateItem = this.updateItem.bind(this);
        this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
        } else {
            window.scrollTo(0, 0)
            const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist')) || [];
            const promoCodeListModule = loginAccessList.find(module => module.ModuleName === "Promo Code List");

            if (promoCodeListModule) {
                const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = promoCodeListModule;

                if (!FullAccess && !ReadAccess) {
                    this.props.navigate('/login'); // Navigate to login if no access
                } else {
                    this.setState({
                        FullAccess: !!FullAccess,
                        ReadAccess: !!ReadAccess,
                        WriteAccess: !!WriteAccess,
                        UpdateAccess: !!UpdateAccess,
                        DeleteAccess: !!DeleteAccess,
                        DownloadAccess: !!DownloadAccess,
                        Is_SpecialAccess: !!Is_SpecialAccess,
                        SendAccess: !!SendAccess
                    });

                    if (FullAccess) {
                        this.setState({
                            ReadAccess: true,
                            WriteAccess: true,
                            UpdateAccess: true,
                            DeleteAccess: true,
                            DownloadAccess: true,
                            Is_SpecialAccess: true,
                            SendAccess: true
                        });
                    }
                }
            } else {
                this.props.navigate('/login');
            }
            if (loginAccessList.length) {
                this.getFillList(industryActionId, '', '', '', '').then(() => {
                    this.getPromoCodeList()
                })
            }
        }
    }

    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true })
        return new Promise((resolve) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === industryActionId) {
                            this.setState({
                                industryList: data.data,
                            })
                            resolve(true)
                        }
                    }
                })
        })
    }

    getPromoCodeList() {
        const { disPer, CouponCode, expiry, status } = this.state
        this.setState({ isLoading: true })
        this.props
            .get_promoCode_list_action(CouponCode, disPer, expiry, status)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({ isLoading: false, promoCodeList: data.data })
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    navPromoDetailsView(id, type) {
        this.props.navigate('/promocode_detail', {
            state: {
                PromoCodeID: id, navType: type
            }
        })
    }
    ExportPromoCode() {
        const { promoCodeList } = this.state;

        if (!promoCodeList || promoCodeList.length === 0) {
            alert("No data available to export.");
            return;
        }

        // Format data: Remove PromoCodeID and format dates
        const formattedData = promoCodeList.map(({ PromoCodeID, ExpiryDate, CreatedDate, ...rest }) => ({
            ...rest,
            ExpiryDate: ExpiryDate ? new Date(ExpiryDate).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "",
            CreatedDate: CreatedDate ?
                new Date(CreatedDate).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) + " " +
                new Date(CreatedDate).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "",
        }));

        const customHeaders = {
            Code: "Promo Code",
            DiscountPercent: "Discount (%)",
            ExpiryDate: "Expiry Date",
            CreatedDate: "Promo Created At",
            Status: "Status",
            IsUsed: "Is Promo Code Used",
            CodeUsedBy: "Promo Code Used By"
        };

        // Convert data to worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData, {
            header: Object.keys(customHeaders),
            skipHeader: true, // We will add custom headers manually
        });

        // Insert headers manually with styles
        const headerKeys = Object.keys(customHeaders);
        headerKeys.forEach((key, index) => {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
            worksheet[cellAddress] = {
                v: customHeaders[key], // Header value
                t: "s", // Type: String
                s: {
                    font: { bold: true, color: { rgb: "FFFFFF" } },
                    alignment: { horizontal: "center", vertical: "center" },
                    fill: { fgColor: { rgb: "4F81BD" } }, // Header background color (blue)
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    }
                }
            };
        });

        // Apply border and alignment to all cells
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let R = 0; R <= range.e.r; ++R) { // Start from the header row
            for (let C = 0; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                if (!worksheet[cellAddress]) continue;
                worksheet[cellAddress].s = {
                    font: R === 0 ? { bold: true } : {}, // Bold font for header row
                    alignment: { horizontal: "center", vertical: "center" },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    }
                };
            }
        }

        // Auto-adjust column width based on content
        worksheet["!cols"] = headerKeys.map((header) => ({
            wch: Math.max(customHeaders[header].length + 2,
                ...formattedData.map((row) => (row[header] ? row[header].toString().length : 10)))
        }));

        // Create and export workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Promo Codes");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
            cellStyles: true,
        });

        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, "PromoCodes.xlsx");
    }

    deleteCoupon(id) {
        this.setState({ isLoading: true })
        this.props
            .delete_promoCode_action(id)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({ isLoading: false }, () => toastSuccess('Coupon Deleted Successfully'))
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    updateItem(item) {
        this.setState({ currentPage: item });
    }
    updateRecordsPerPage = (count) => {
        this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
    };

    promoCodeRecord(promoCodeList) {
        return (
            <table className="table table-bordered table-striped mg-b-0">
                <thead>
                    <tr>
                        <th>Coupon Code</th>
                        <th>% Discount</th>
                        <th>Expiry Date</th>
                        <th>Status</th>
                        <th>Coupon Created Date</th>
                        <th>Coupon Used Date</th>
                        <th>Coupon Used By</th>
                        <th className='text-center'>Action</th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {promoCodeList.length > 0 ? promoCodeList.map((data) => (
                        <tr>
                            <td>{data.Code}</td>
                            <td>{data.DiscountPercent}</td>
                            <td>{moment(data.ExpiryDate).format('DD-MMM-yyyy')}</td>
                            <td>{data.Status}</td>
                            <td>{moment(data.CreatedDate).format('DD-MMM-yyyy')}</td>
                            <td>{data.IsUsed}</td>
                            <td>{data.CodeUsedBy ? data.CodeUsedBy : '-'}</td>
                            <td className="text-center" style={{ width: '10%' }}>
                                <a
                                    // href="javascript:void(0);"
                                    onClick={() => this.navPromoDetailsView(data.PromoCodeID, 1)}
                                    title="View Invoice"
                                    className="load_document_icon mx-2"
                                    data-toggle="modal"
                                    data-target="#add_comment_modal"
                                >
                                    <i className="fa fa-eye" />
                                </a>
                                <a
                                    // href="javascript:void(0);"
                                    onClick={() => this.navPromoDetailsView(data.PromoCodeID, 2)}
                                    title="View Invoice"
                                    className="load_document_icon mx-2"
                                    data-toggle="modal"
                                    data-target="#add_comment_modal"
                                >
                                    <i className="fa fa-pencil" />
                                </a>
                                <a
                                    // href="javascript:void(0);"
                                    onClick={() => this.deleteCoupon(data.PromoCodeID)}
                                    title="View Invoice"
                                    className="load_document_icon mx-2"
                                    data-toggle="modal"
                                    data-target="#add_comment_modal"
                                >
                                    <i className="fa fa-trash" />
                                </a>
                            </td>

                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={10}>No Record Found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    toggleFilterCollapse() {
        this.setState((prevstate) => ({
            isFilterShow: !prevstate.isFilterShow
        }))
    }
    render() {
        const { isLoading, disPer, CouponCode, currentPage, promoCodeList, isFilterShow, expiry, status, recordsPerPage } = this.state
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = promoCodeList.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(promoCodeList.length / recordsPerPage);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">
                        <div class="row mt-15">
                            <section className="table_section">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-lg-12">
                                            <div className="card shadow-none border mb-2" >
                                                <div className="card-header py-1">
                                                    <h6 className='pt-2' style={{ float: 'left' }}>Promo Code List</h6>
                                                    {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') ? <>
                                                        <a style={{ float: 'right' }}
                                                            href="javascript:void(0);"
                                                            className="btn btn-purple custom_btn"
                                                            title="Filter"
                                                            data-toggle="modal"
                                                            data-target="#filter_modal"
                                                            onClick={() => this.toggleFilterCollapse()}
                                                        >
                                                            <i className="fa fa-filter" />
                                                        </a>
                                                        <a style={{ float: 'right' }}
                                                            href="javascript:void(0);"
                                                            title="Add Promo Code"
                                                            onClick={() => this.navPromoDetailsView(null, 3)}
                                                            className="load_document_icon  p-1 px-2 send_credentials-btn mx-1"
                                                            data-toggle="modal"
                                                            data-target="#add_comment_modal"
                                                        >
                                                            Add
                                                        </a>
                                                        <a style={{ float: 'right' }}
                                                            href="javascript:void(0);"
                                                            title="Export Excel"
                                                            onClick={() => this.ExportPromoCode()}
                                                            className="load_document_icon  p-1 px-2 send_credentials-btn mx-1"
                                                            data-toggle="modal"
                                                            data-target="#add_comment_modal"
                                                        >
                                                            Export
                                                        </a>
                                                    </> : <></>}
                                                </div>
                                                <ul className="list-group list-group-flush">
                                                    {isFilterShow && <>
                                                        <li className="list-group-item">
                                                            <div className="row ">
                                                                <div className="col-xl-2 mb-2">
                                                                    <div class="form-group">
                                                                        <label>Coupon Code</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            value={CouponCode}
                                                                            // onKeyDown={e => this.handleKeyDown(e)}
                                                                            onChange={(e) => this.setState({ CouponCode: e.target.value })}
                                                                        />
                                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{exhibitorErr}</span>} */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 mb-2">
                                                                    <div class="form-group">
                                                                        <label>% Discount</label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            value={disPer}
                                                                            // onKeyDown={e => this.handleKeyDown(e)}
                                                                            onChange={(e) => this.setState({ disPer: e.target.value })}
                                                                        />
                                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{exhibitorErr}</span>} */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 mb-2">
                                                                    <div class="form-group">
                                                                        <label>Expiry Date</label>
                                                                        <input
                                                                            type="date"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            value={expiry}
                                                                            onChange={(e) => this.setState({ expiry: e.target.value })}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 mb-2">
                                                                    <div class="form-group">
                                                                        <label>Status</label>
                                                                        <select className="form-control" value={status} id="privileges" onChange={(e) => this.setState({ status: e.target.value })}>
                                                                            <option value={''}>Select</option>
                                                                            <option value={1}>Active</option>
                                                                            <option value={0}>InActive</option>
                                                                        </select>
                                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{exhibitorErr}</span>} */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 mb-3">
                                                                    < button style={{ marginTop: '20px' }} className='btn btn-primary mr-2' onClick={() => this.getPromoCodeList()}>
                                                                        Search
                                                                    </button>
                                                                    <button type="button" style={{ marginTop: '20px' }} className='btn btn-dark  mr-2 ms-2' onClick={() => this.setState({
                                                                        disPer: '', CouponCode: '', expiry: '', status: 1
                                                                    }, () => {
                                                                        this.getPromoCodeList()
                                                                    })}>
                                                                        Clear
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </>}
                                                </ul>
                                            </div>
                                            <div className="card shadow-none border">

                                                <div className="card-body p-2 pb-0">

                                                    <div className="custom_table">
                                                        <div className="hack1">
                                                            <div className="hack2">
                                                                {this.promoCodeRecord(currentRecords)}
                                                                {promoCodeList.length > 0 ? (
                                                                    <Pagination
                                                                        nPages={nPages}
                                                                        currentPage={currentPage}
                                                                        setCurrentPage={this.updateItem}
                                                                        totalRecords={promoCodeList.length}
                                                                        pageLength={recordsPerPage}
                                                                        setPageLength={this.updateRecordsPerPage}
                                                                    />
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>

                    </div >
                </section >
                {/* <Footer /> */}

            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, get_promoCode_list_action, delete_promoCode_action })(PromoCodeList));
